import { Switch } from "@mui/material";

export const deviceColumns = [
  { Header: "#", accessor: "#", width: "10%", align: "left" },
  { Header: "Device", accessor: "device" },
  { Header: "Calibration", accessor: "calibration", width: "27.5%", align: "left" },
  { Header: "Correction", accessor: "correction", width: "27.5%", align: "left" },
];

export const formatDeviceTableData = (devices, updateDeviceConfig) => {
  if (!devices) return [];
  return devices.map((device, i) => ({
    "#": ++i,
    device: device.id,
    calibration: (
      <Switch
        checked={device.calibration}
        onChange={(e) => updateDeviceConfig(device.id, "calibration", e.target.checked)}
        color="success"
      />
    ),
    correction: (
      <Switch
        checked={device.correction}
        onChange={(e) => updateDeviceConfig(device.id, "correction", e.target.checked)}
        color="success"
      />
    ),
  }));
};
